import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles((theme) => ({
  
  actionButton: {
    color: theme.props.text.alt,
  },
}));

export default useStyle;
